import {
  SET_TRANSACTION_FAILED,
  SET_TRANSACTION_SUCCESS,
  UPDATE_TRANSACTION_IN_PROGRESS
} from '../storage/TransactionsInProgressReducer';

const ERR_TRANSACTION_HAS_BEEN_REVERTED = 'Transaction has been reverted by the EVM:';
const ERR_USER_DENIED_TX = 'Returned error: Error: MetaMask Tx Signature: User denied transaction signature.';

export function addTransactionInProgress (hash, action, validationMessage) {
  Storage.dispatch({
    type: UPDATE_TRANSACTION_IN_PROGRESS,
    payload: {
      txHash: hash,
      action: action,
      validationMessage: validationMessage || 'Transaction failed.'
    }
  });
}

export function transactionReceiptHandler (receipt, handler) {
  if (!receipt.status) {
    console.log('transaction failed', receipt);
    Storage.dispatch({
      type: SET_TRANSACTION_FAILED,
      payload: {
        txHash: receipt.transactionHash
      }
    });

    return;
  }

  handler();

  Storage.dispatch({
    type: SET_TRANSACTION_SUCCESS,
    payload: {
      txHash: receipt.transactionHash
    }
  });
}

export function transactionErrorHandler (err, receipt) {
  console.log(err, receipt);
  if (receipt) {
    console.log('Transaction out of gas error');
  }

  if (err.message.startsWith(ERR_TRANSACTION_HAS_BEEN_REVERTED)) {
    let errorReceiptJsonString = err.message.replace(ERR_TRANSACTION_HAS_BEEN_REVERTED, '');
    let receipt = JSON.parse(errorReceiptJsonString);

    showValidationErrorsFromReceipt(receipt);

    return;
  }

  if (err.message.startsWith(ERR_USER_DENIED_TX)) {
    return;
  }

  console.error(err);
}

function showValidationErrorsFromReceipt (receipt) {
  Storage.dispatch({
    type: SET_TRANSACTION_FAILED,
    payload: {
      txHash: receipt.transactionHash
    }
  });
}


// WEBPACK FOOTER //
// ./src/utils/TransactionStateHelper.js